module.exports = __webpack_public_path__ + "media/animation_logo.d1a9d9e8.mp4";